module.exports = __webpack_public_path__ + "static/media/WipeYourPhone.e111f052.png";